import { atom, useRecoilState } from 'recoil';
import { useEffect } from "react";
import { db } from '../app.js';
import { doc, getDoc, getDocFromCache, setDoc } from 'firebase/firestore';


export const workflowIDAtom = atom({
    key: 'workflowID',
    default: ''
});

export const workflowAtom = atom({
    key: "workflowAtom",
    default: {}
});

export const componentBeingEditedIDAtom = atom({
    key: "componentBeingEditedIDAtom",
    default: ""
});

export const securityTagsAtom = atom({
    key: "securityTagsAtom",
    default: []
});

export const processImageAtom = atom({
    key: "processImageAtom",
    default: {}
});

export const formDirtyAtom = atom({
    key: "formDirtyAtom",
    default: false,
  });

export const Data = () => {

    const [workflowID, setWorkflowID] = useRecoilState(workflowIDAtom);
    const [workflow, setWorkflow] = useRecoilState(workflowAtom);
    const [componentBeingEditedID, setComponentBeingEditedID] = useRecoilState(componentBeingEditedIDAtom);

    useEffect(() => {

        if (workflowID !== '' && workflowID !== undefined) {
            console.log("IN DATA.js workflowID passed is: ", workflowID);
            getWorkflow(workflowID);
        }
    }, [workflowID]);

    useEffect(() => {
        console.log("IN processImageAtom: ");
    }, [processImageAtom]);

    useEffect(() => {

        if (workflow.id !== undefined) {
            console.log("IN DATA.JS WORKFLOW CURRENTLY = ", workflow);
            saveWorkflow(workflow);
        }

    }, [workflow]);

    useEffect(() => {
        console.log("In Data.js componentBeingEditedID = ", componentBeingEditedID);
    }, [componentBeingEditedID]);

    async function getWorkflow(id) {

        console.log("IN DATA.js GET WORKFLOW, ID = ", id);

        const docRef = doc(db, "workflows", id);
        let docSnap;

        if (!navigator.onLine) {
            try {
                docSnap = await getDocFromCache(docRef);
            } catch (e) {
                console.warn("Offline cache miss:", e);
                return;
            }
        } else {
            docSnap = await getDoc(docRef);
        }

        if (docSnap.exists()) {
            console.log("IN DATA GET WORKFLOW, DATA = ", docSnap.data());
            setWorkflow(docSnap.data());
        } else {
            console.log("IN DATA.js GET WORKFLOW CALLED - No such workflow document!");
        }
    }

    async function saveWorkflow(data) {
        console.log("IN DATA.js: IN SAVE WORKFLOW = ", data, "workflowID = ", workflowID);
        const docRef = doc(db, "workflows", workflowID);
        await setDoc(docRef, data);
    }

};

export default Data;
